import { z } from 'zod';

export const viewingAsSchema = z.object({
  id: z.string().min(1),
  name: z.string().nullish(),
  email: z.string().nullish(),
  isStaff: z.boolean().nullish(),
});
export type ViewingAsDto = z.infer<typeof viewingAsSchema>;

/** GET /v2/auth/session: `user` is null when the account behind the cookie is gone. */
export const sessionAnswerSchema = z.object({
  user: z.record(z.unknown()).nullable(),
  viewingAs: viewingAsSchema.nullish(),
  landingPage: z.string().nullish(),
});

/** Who the person is. Sign-in stands on it, so a drifted field here fails the session loudly. */
export const sessionIdentitySchema = z.object({
  _id: z.string().min(1),
  name: z.string().nullish(),
  email: z.string().nullish(),
  isStaff: z.boolean().nullish(),
});
export type SessionIdentityDto = z.infer<typeof sessionIdentitySchema>;

/**
 * What the server keeps about the person. Only the screens that show it depend on it, so a drifted
 * field fails those screens and never sign-in. Anything else the server sends is dropped here.
 */
export const personDetailsSchema = z.object({
  number: z.string().nullish(),
  language: z.string().nullish(),
  isPhoneNumberVerified: z.boolean().nullish(),
  isEmailAddressVerified: z.boolean().nullish(),
  passwordSet: z.boolean().nullish(),
  profilePic: z.string().nullish(),
  defaultPage: z.unknown().optional(),
});
export type PersonDetailsDto = z.infer<typeof personDetailsSchema>;

export const viewAsAnswerSchema = z.object({
  layoutInfo: z.object({ landingPage: z.string().nullish() }).nullish(),
});

export const viewablePeopleSchema = z.object({
  people: z.array(
    z.object({
      _id: z.string().min(1),
      name: z.string().nullish(),
      email: z.string().nullish(),
    }),
  ),
});
